import { SecondaryCard } from "@clockwise/web-commons/src/ui/event-thread";
import { Tooltip } from "@material-ui/core";
import React from "react";
import { AttendeeThreadHeader } from "./util/proposal-thread.util";

const EndText = ({ type }: { type: SecondaryCard }) => {
  switch (type) {
    case "unavailable":
      return <span>I can't fix:</span>;
    case "sbm":
      return (
        <Tooltip
          title={
            <div className="cw-body-sm cw-text-onEmphasis">
              Clockwise will only move other users' events if they are Flexible.
            </div>
          }
          placement="top"
        >
          <span className="cw-underline cw-decoration-dashed cw-decoration-[#D9D9D9] cw-underline-offset-4 cw-font-medium cw-whitespace-nowrap">
            can move:
          </span>
        </Tooltip>
      );
  }
};

export const ThreadItemHeader = ({
  attendeesInfo,
  type,
}: {
  attendeesInfo: AttendeeThreadHeader;
  type: SecondaryCard;
}) => {
  const attendeesCount = attendeesInfo.names.length;
  if (attendeesCount === 0) return null;

  let affectedNoun = `${attendeesCount} attendees`;
  let affectedVerb = "have";
  if (attendeesCount === 1) {
    // I specifically don't just check if the name is "You", because the name could be "You" and the user is not the current user
    // If you think this case is too crazy you can simplify it
    if (attendeesInfo.hasCurrentUser) {
      affectedNoun = "You";
      affectedVerb = "have";
    } else {
      affectedNoun = attendeesInfo.names[0];
      affectedVerb = "has";
    }
  }

  return (
    <span className="cw-font-normal">
      <span className="cw-font-medium">{affectedNoun} </span>
      {affectedVerb} conflicts that <EndText type={type} />
    </span>
  );
};
